import { render } from "./Navitem.vue?vue&type=template&id=1f85f784"
import script from "./Navitem.vue?vue&type=script&lang=js"
export * from "./Navitem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__